import React from 'react';

import './NewLoader.css';

// Add c-content-loading to mother Tag

const Newloader = props => (
  <div className="c-loading__container">
      <div className="c-loading__loading-img"></div>
    </div>
);

export default Newloader;




